<div [class]="layout.shell">
  <header [class]="layout.header">
    <div class="flex items-center gap-2">
      <mat-icon class="h-5! w-5! shrink-0 text-xl! leading-5! text-primary-600">event_available</mat-icon>
      <h2 class="min-w-0 flex-1 truncate text-lg! leading-5! font-semibold! text-neutral-800">{{ data.titleKey | translate }}</h2>
    </div>

    <!-- Names the record rather than describing the act: a manager must see what this is about. -->
    <p class="truncate pl-7 text-sm text-neutral-500">{{ data.subject }}</p>

    @if (data.count && data.count > 1) {
      <p class="pl-7 text-sm text-neutral-400">{{ "guaranteeV2.message.outcomeAppliesTo" | translate: { count: data.count } }}</p>
    }
  </header>

  <div [class]="layout.body">
    <!-- Offered only where both answers are real: a course-wide stop has nothing to say about delivery. -->
    @if (data.offersFulfilled) {
      <fieldset class="flex flex-col gap-1.5">
        <legend
          guaranteesLabel
          required
          class="pb-1"
          [missing]="!canConfirm()"
        >
          {{ "guaranteeV2.label.fulfillmentOutcome" | translate }}
        </legend>

        <button
          guaranteesToggle
          shape="card"
          layout="block"
          size="lg"
          align="start"
          type="button"
          [pressed]="fulfilled() === true"
          (click)="setFulfilled(true)"
        >
          <mat-icon
            class="mt-0.5 h-4! w-4! shrink-0 text-base! leading-4!"
            [class]="fulfilled() === true ? 'text-success-600' : 'text-neutral-400'"
            >task_alt</mat-icon
          >
          <span class="flex min-w-0 flex-1 flex-col gap-0.5">
            <span class="text-sm font-semibold text-neutral-700">{{ "guaranteeV2.action.markFulfilled" | translate }}</span>
            <span class="text-sm text-neutral-500">{{ "guaranteeV2.message.markFulfilledHint" | translate }}</span>
          </span>
        </button>

        <button
          guaranteesToggle
          shape="card"
          layout="block"
          size="lg"
          align="start"
          type="button"
          [pressed]="fulfilled() === false"
          (click)="setFulfilled(false)"
        >
          <mat-icon
            class="mt-0.5 h-4! w-4! shrink-0 text-base! leading-4!"
            [class]="fulfilled() === false ? 'text-error-600' : 'text-neutral-400'"
            >stop_circle</mat-icon
          >
          <span class="flex min-w-0 flex-1 flex-col gap-0.5">
            <span class="text-sm font-semibold text-neutral-700">{{ "guaranteeV2.action.stopFulfillment" | translate }}</span>
            <span class="text-sm text-neutral-500">{{ "guaranteeV2.message.stopFulfillmentHint" | translate }}</span>
          </span>
        </button>
      </fieldset>
    }

    @if (collectsStopReason()) {
      <fieldset class="flex flex-col gap-1.5">
        <legend
          guaranteesLabel
          class="pb-1"
        >
          {{ "guaranteeV2.label.stopReason" | translate }}
        </legend>

        <div class="flex flex-wrap gap-1.5">
          @for (reason of stopReasons; track reason) {
            <button
              guaranteesToggle
              shape="pill"
              size="md"
              type="button"
              [pressed]="stopReason() === reason"
              (click)="stopReason.set(reason)"
            >
              <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">{{ stopReasonIcon[reason] }}</mat-icon>
              {{ stopReasonLabelKey[reason] | translate }}
            </button>
          }
        </div>
      </fieldset>
    }
  </div>

  <footer [class]="layout.footer">
    <button
      class="inline-flex items-center rounded-full px-3 py-1.5 text-sm font-medium text-neutral-500 transition-colors duration-150 hover:bg-neutral-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
      type="button"
      (click)="cancel()"
    >
      {{ "guaranteeV2.action.cancel" | translate }}
    </button>

    <button
      class="ml-auto inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-sm font-semibold text-neutral-0 transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none disabled:bg-neutral-300 motion-reduce:transition-none"
      type="button"
      [class]="confirmClass()"
      [disabled]="!canConfirm()"
      (click)="confirm()"
    >
      <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">{{ confirmIcon() }}</mat-icon>
      {{ confirmKey() | translate }}
    </button>
  </footer>
</div>
